"use client"
import React from 'react'
import styles from './survey.module.scss'
import Icon from '@components/icon'
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons'
import useSurveys from './useSurveys'
import { IStation, ISurvey } from '@models'
import Loader from '@components/loader'
import Button from '@components/buttons/button'
import Link from 'next/link'

export default function Surveys({ station, initial }: { station: IStation, initial: ISurvey[] }) {
    const { surveys, showing, vote, nextSurvey, voted, loading } = useSurveys(station.id, initial)
    if (!surveys.length) return null
    return (
        <div className={styles.container} id="surveys">
            <h3>
                {surveys[showing].question.replace(/{station_name}/g, station.name)}
                {loading && <Loader size={20} />}
            </h3>
            <div className={styles.answers}>
                {surveys[showing].answers.map((answer, i) => (
                    <div className={`click animated ${voted === i && styles.active}`} onClick={() => vote(i)} key={i}>
                        <div>
                            <Icon icon={faChevronCircleLeft} />
                            {answer.text}
                        </div>
                        {
                            voted > -1 && (
                                <>
                                    <span style={{width: `${answer.percentage}%`}} />
                                    <i>{answer.percentage}%</i>
                                </>
                            )
                        }
                    </div>
                ))}
            </div>
            {
                surveys.length > 1 && (
                    <div className={styles.buttons}>
                        <Link href="/contact" target='_blank'>
                            אחר? ספרו לנו כאן
                        </Link>
                        <Button onClick={nextSurvey} className={styles.button}>
                            <Icon icon={faChevronCircleLeft} />
                            מעבר לסקר הבא
                        </Button>
                    </div>
                )
            }
        </div>
    )
}